<script>
  import config from '../../libs/config.json';
  import func from '../../libs/functions.js';
    import axios from 'axios'
  import _system from '../../libs/system';
  import { mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'
	
	export default 
	{
		name: 'IntroductionTeam',
		data() 
        {
        	return {
            func: func,
            show: {
              teammateModal : false
            },
            loading: {
              workspaces: true,
              workspaceusers: true,
              addTeammate: false
            },
            activeWorkspaceId: '',
            newTeammate: {
              name:'',
              email: '',
              tags: [],
              department: {
                name: 'Admin',
                _id: ''
              }
            }
        	}
        },
        computed: {
          ...mapGetters('session', ['isLoggedIn', 'getUser']),
          ...mapGetters('workspaces', ['currentWorkspace','workspaces', 'workspacesById']),
          ...mapGetters('tags', ['tags', 'tagsByName', 'tagsByTypeName']),  
          ...mapGetters('workspaceusers', ['workspaceusers'])          
        },
      methods: {
        ...mapActions('tags', ['setTags']),
        ...mapActions('session', ['setUser']),
        ...mapActions('workspaces', ['setWorkspaces']),        
        ...mapActions('workspaceusers', ['setWorkspaceusers']),        
        next(){
          this.$router.push({ name: "introductionPage" });
        },
        addTeammate(){

          this.loading.addTeammate = true

          this.newTeammate.name = func.extractName(this.newTeammate.email);

          let payload = this.newTeammate;

          payload.with = 'InvitationEmail';

          _system.services.user.create(payload, (err, data) => {
            if(err) {
              const payload = {
                query: {
                  email: this.newTeammate.email
                }
              }
              //const user = await _system.services.user.getUseIdrByEmail(payload)

              _system.services.user.getUserByEmail(payload, (err, user) => {
                
              let payload = {
                workspace: this.currentWorkspace._id,
                user:  user._id,
                tags :  [this.tagsByName[this.newTeammate.department.name]._id, this.tagsByName['Invited']._id]
              }
              
                _system.services.workspaceusers.addWith(payload, (err, workspaceusers) => {
                  if(err) return console.log(err);

                    this.setWorkspaceusers(workspaceusers);

                                          //Password emaili tetikler
                      //gecici password set et
                      window.analytics.identify(user._id, {
                        id: data.user._id,
                        email: data.user.email
                      });

                      setTimeout(() => {
                        window.analytics.track('User Invited');
                      },6000)

                      setTimeout(() => {
                          window.analytics.identify(this.getUser._id, {
                            id: this.getUser._id,
                            email: this.getUser.email
                          });
                      },12000)
                      //password emaili tetiklendi
                
                      this.show.teammateModal = false;
                      this.loading.addTeammate = false

                        // Reset
                        this.newTeammate = { name: '', email: '', department: { name: 'Admin', _id: this.tagsByName['Admin']._id } }
                })
              });
            }else{
              // 1 - Add the registered user into His/Her workspace 
              let payload1 = { "name":"Your Workspace", tags: [this.tagsByName['Individual']._id] }
              _system.services.workspaces.create(payload1, (err, workspace) => {
                if (err) return console.log(err);
                let payload2 = {
                  query: {
                    email: this.newTeammate.email
                  }
                };
                _system.services.user.getUserByEmail(payload2, (err, user) => {
                  let payload3 = {
                    workspace: workspace._id,
                    user:  user._id,
                    tags :  [this.tagsByName['Admin']._id]
                  }
                  _system.services.workspaceusers.add(payload3, (err, data) => {
                    if (err) return console.log(err);
                  });
              })
              })
              // 2 - Add the registered user into current workspace              
                let payload = {
                  workspace: this.currentWorkspace._id,
                  user:  data.user._id,
                  tags :  [this.tagsByName[this.newTeammate.department.name]._id, this.tagsByName['Invited']._id],
                }
                _system.services.workspaceusers.add(payload, (err, workspaceusers) => {
                  if(err) return console.log(err);

                  this.setWorkspaceusers(workspaceusers);

                  //Password emaili tetikler
                  //gecici password set et
                  window.analytics.identify(data.user._id, {
                    id: data.user._id,
                    email: data.user.email
                  });
                
                      setTimeout(() => {
                        window.analytics.track('User Invited', {
                          token: data.accessToken,
                          reset: 'true'
                        });
                      },6000)


                  setTimeout(() => {
                      window.analytics.identify(this.getUser._id, {
                        id: this.getUser._id,
                        email: this.getUser.email
                      });
                  },12000)
                      //password emaili tetiklendi
              
                  this.show.teammateModal = false;
                  this.loading.addTeammate = false

                  // Reset
                  this.newTeammate = { name: '', email: '', department: { name: 'Admin', _id: this.tagsByName['Admin']._id } }
                })
              }
            })
        }
      },

        created() {

          console.log(this.currentWorkspace._id)

/*           if(!this.tags.length){
            _system.services.tags.get((err, tags) => {
              this.setTags(tags);
            })
          }


          if(!this.workspaces.length){

            _system.services.workspaces.get({ _id: this.getUser._id },(err, workspaces) => {
              console.log(workspaces);
                this.setWorkspaces(workspaces);   

                    _system.services.workspaceusers.get({ _id : this.currentWorkspace._id }, (err, workspaceusers) => { 
                      this.setWorkspaceusers(workspaceusers);
                      this.loading.workspaceusers = false;
                    })                           
                  })

          }else{

          if(!this.workspaceusers.length){
            _system.services.workspaceusers.get({ _id : this.currentWorkspace._id }, (err, workspaceusers) => { 
              this.setWorkspaceusers(workspaceusers);
              this.loading.workspaceusers = false;
            })
          }else{
            this.loading.workspaceusers = false;
          }

          } */
          
          

        }
	}
</script>

<template>
  <div style="height:100%;" class="ui grid centered middle aligned stackable">

    <div data-aos="zoom-in" class="nine wide column">
      <table>
        <tbody>
          <tr>
            <td style="padding-right: 1rem;opacity: 0.2;" data-label="Name"> <b>Step 1</b> - Create Online Workspace</td>
            <td style="padding-right: 1rem; " data-label="Name"><b>Step 2</b> - Setup Team</td>
            <td style="padding-right: 1rem; opacity: 0.2;" data-label="Name"><b>Step 3</b> - Connect Social Accounts 🚀</td>
          </tr>
        </tbody>
      </table>
   <div class="ui divider"></div>
      <div class="ui basic large segment">
        <h2>Team 💪</h2>
        <p>Let's add teammates for <b>{{ currentWorkspace.name}}</b> </p> <p> Invite your team members through their email address and assign their role on Juphy.</p>

        <div v-if="loading.addTeammate" class="ui basic segment center aligned">
          <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
        </div>

        <div v-if="workspaceusers.length" class="ui list selection">
          <div v-for=" teammate in workspaceusers" :key="teammate._id" class="item">
            <div class="right floated content">
              <!-- <button class="ui icon button" :disabled="(teammate.tags[0].name == 'Admin')"> <i class="trash icon"></i> </button> -->
            </div>
             <img class="ui avatar image" :src="'/img/avatar/roboto/128/latin_'+ func.getFirstLetter(teammate.user.email) +'.png'">
            <div class="content">
              <a class="header">{{teammate.user.email}}</a>
              <span style="font-style: italic; font-size: 12px;"> {{teammate.role.name}} </span>
            </div>
          </div>
          </div>

          <div v-if="show.teammateModal" class="ui basic delight segment">
          <div class="ui form">
          <div class="field">
            <label>Email</label>
            <input v-model="newTeammate.email" placeholder="joe@company.com" type="text" :disabled="loading.addTeammate">
          </div>
            <div class="field">
              <label>Roles</label>
              <select v-model="newTeammate.department.name" :disabled="loading.addTeammate">
                <option v-for="role in tagsByTypeName['Role']" :key="role._id" >{{role.name}}</option>
              </select>
              <div class="ui small info message">
                <div class="header">
                  Role Permissions
                </div>
                <ul class="list">
                  <li><b>Admin</b> can add/remove social accounts and see the statistics and performance of Moderator team.</li>
                  <li><b>Moderator</b> can only reach the social inbox and reply customer messages.</li>
                </ul>
              </div>
            </div>
          <button @click="addTeammate()" class="ui orange button fluid" v-bind:class="{ loading: loading.addTeammate }" :disabled="loading.addTeammate"> <i class="paper plane outline icon"></i> Invite</button>
          </div>
          </div>
          <div v-if="!show.teammateModal" @click="show.teammateModal = true" class="ui small button fluid"><i class="user plus icon"></i> Invite Teammate</div>
          <div class="ui divider"></div>
          <div class="ui form">
          <div v-if="workspaceusers.length > 1" @click="next();" class="ui large blue button right floated">Save & Continue</div>
          <div @click="next();" style="background: transparent;" class="ui large button right floated">Setup Later <i class="long arrow alternate right icon"></i> </div>
        </div>
      </div>
    </div>

  </div>

</template>



// WEBPACK FOOTER //
// src/components/dashboard/introductionTeam.vue